// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"191eaf5f","654":"a69b5404"}[chunkId] + ".chunk.js";
};